import {GqlModel, GqlModelOperator, GqlQueryModel} from "../../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../../json.model";

const CUSTOMER_RESELLER_TOPIC = "custReseller";

export class CustResellerGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<CustResellerGqlModel>
    = GqlModel.buildMapper(CustResellerGqlModel, CUSTOMER_RESELLER_TOPIC);

  static query: any = gql`
    subscription ${CUSTOMER_RESELLER_TOPIC}($projectId: ID!) {
      ${CUSTOMER_RESELLER_TOPIC}(projectId: $projectId) {
        __typename
        ... on CustResellerInfo {
          customerName,
          customerBpId,
          customerState,
          customerMessage,
          customerErrorMessages,
          resellerErrorMessages,
          resellerName,
          resellerBpId,
          resellerState,
          resellerMessage,
        }
      }
    }`;

  static variables(projectId: string) {
    return {projectId};
  }

  @jsonProperty("string") customerName: string;
  @jsonProperty("string") customerBpId: string;
  @jsonProperty("number") customerState: number;
  @jsonProperty("string") customerMessage: string;
  @jsonProperty("json") customerErrorMessages: object[];
  @jsonProperty("json") resellerErrorMessages: object[];
  @jsonProperty("string") resellerName: string;
  @jsonProperty("string") resellerBpId: string;
  @jsonProperty("number") resellerState: number;
  @jsonProperty("string") resellerMessage: string;

  constructor(data: any) {
    super(data);
  }
}

export class CustResellerInfoGqlModel extends CustResellerGqlModel {
  customerName: string;
  customerBpId: string;
  customerState: number;
  customerMessage: string;
  customerErrorMessages: object[];
  resellerErrorMessages: object[];
  resellerName: string;
  resellerBpId: string;
  resellerState: number;
  resellerMessage: string;

  constructor(data: any) {
    super(data);
    data = data || {};
    this.customerName = data.customerName;
    this.customerBpId = data.customerBpId;
    this.customerState = data.customerState;
    this.customerMessage = data.customerMessage;
    this.customerErrorMessages = data.customerErrorMessages;
    this.resellerErrorMessages = data.resellerErrorMessages;
    this.resellerName = data.resellerName;
    this.resellerBpId = data.resellerBpId;
    this.resellerState = data.resellerState;
    this.resellerMessage = data.resellerMessage;
  }
}

CustResellerGqlModel.register("CustResellerInfo", CustResellerInfoGqlModel);
